// extracted by mini-css-extract-plugin
export var root = "list-module--root--3f76d";